import React from 'react'
import { INFTSharModalProps } from './INFTShareModel'
import Modal from '../../../../components/Modal'
import { NFTShareModalMeta, NFTShareModalWrapper, NFTShareModalShareLinks } from './styled'
import {
  TwitterIcon,
  TwitterShareButton,
  TelegramIcon,
  TelegramShareButton,
  EmailIcon,
  EmailShareButton
} from 'react-share'

export default function NFTShareModal({ isOpen, onDismiss, shareText }: INFTSharModalProps) {
  const shareUrl = window.location.href
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} maxHeight={90}>
      <NFTShareModalWrapper>
        <NFTShareModalMeta>Share link to this page</NFTShareModalMeta>
        <NFTShareModalShareLinks>
          <div className="nft-share-button">
            <TwitterShareButton url={shareUrl} title={shareText}>
              <TwitterIcon size={32} />
            </TwitterShareButton>
            <div className="nft-share-button-text">Twitter</div>
          </div>
          <div className="nft-share-button">
            <TelegramShareButton url={shareUrl} title={shareText}>
              <TelegramIcon size={32} />
            </TelegramShareButton>
            <div className="nft-share-button-text">Telegram</div>
          </div>
          <div className="nft-share-button">
            <EmailShareButton url={shareUrl} body={shareText}>
              <EmailIcon size={32} />
            </EmailShareButton>
            <div className="nft-share-button-text">Email</div>
          </div>
        </NFTShareModalShareLinks>
      </NFTShareModalWrapper>
    </Modal>
  )
}
